import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { TiposTablaPersonalizadaConstant } from 'constants/index'

import * as TablaPersonalizadaService from 'services/tablasPersonalizadas.service'

const PlantillaComentarioFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const [plantillas, setPlantillas] = React.useState([])

  React.useEffect(() => {
    TablaPersonalizadaService.getAsSelect(
      TiposTablaPersonalizadaConstant.PLANTILLACOMENTARIOVENTA
    ).then(({ data }) => setPlantillas(data))
  }, [])

  return (
    <Form.Group>
      <Form.Label text='PLANTILLA COMENTARIO' htmlFor='select-plantillaComentario' md={3} />
      <Col md={9}>
        <Field name='_idPlantillaComentario'>
          {({ field }) => (
            <Form.Select
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-plantillaComentario'
            >
              <option value=''>Seleccionar</option>
              {plantillas &&
                plantillas.map((val, key) => (
                  <option key={key} value={val._id}>
                    {val.nombre}
                  </option>
                ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(PlantillaComentarioFormGroup)
